import React, { useMemo, useState, useRef } from "react";
import styled from "styled-components";
import { Col, Form, Row, Modal, Table, Tag, Spin } from "antd";
// import { ButtonFilled, ButtonOutlined } from "../reusableComponent/UIButtons";
import { useHistory } from "react-router-dom";
import Active from "./Active";
import queryKeys from "../../common/queryKey";
import { useSelector } from "react-redux";
// import { getFilters } from "../../Redux/selectors";
import { useScrollFetch } from "../../hooks/useScrollFetch";
import { Menu, MenuItem } from "@mui/material";
import { utils, writeFileXLSX, read } from "xlsx";
// import { toast } from "react-toastify";
import { getFilters } from "redux/selectors";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { CALL_API_UPDATED } from "../../common/API";

const ClientWrapStyle = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const TEMPLATE_HEADERS = [
    "Company Registered Name*",
    "Managing Office* (Zambia/Mauritius)",
    "Relationship Type*",
    "Primary Contact Person*",
    "Primary Contact Email*",
    "Influential Star Customer* (Yes/No)",
    "Current Nature of Engagement*",
    "Login Office Email*",
    "Login Password*",
    "BC Client ID*",
    "Risk Classification*",
    "Review Cycle Period* (Annual/Quarterly/Monthly)",
    "Status* (Active/Inactive)",
    "Last Date Included in Campaign*",
    "BR Flag Value*",
    "Designation Template*",
    "Created Date*",
    "Archive Reason*",
    "Archive Date*",
    "Strategic Partner* (Yes/No)",
    "Business Designation Type*",
    "Designation Level / Location Hierarchy*",
    "Owner",
    "Company Email",
    "Registration No",
    "Country",
    "City",
    "Website URL",
    "Description",
];

const HEADER_TO_FIELD = {
    "Company Registered Name*": "companyRegisteredName",
    "Managing Office* (Zambia/Mauritius)": "managingOffice",
    "Relationship Type*": "relationshipType",
    "Primary Contact Person*": "primaryContactPerson",
    "Primary Contact Email*": "primaryContactEmail",
    "Influential Star Customer* (Yes/No)": "influentialstarCustomer",
    "Current Nature of Engagement*": "currentNatureofEngag",
    "Login Office Email*": "loginOfficeEmail",
    "Login Password*": "loginPassword",
    "BC Client ID*": "bcClientId",
    "Risk Classification*": "riskClassification",
    "Review Cycle Period* (Annual/Quarterly/Monthly)": "reviewCyclePeriod",
    "Status* (Active/Inactive)": "status",
    "Last Date Included in Campaign*": "lastDateCampaign",
    "BR Flag Value*": "brFlagValue",
    "Designation Template*": "designationTemplate",
    "Created Date*": "createdDate",
    "Archive Reason*": "archiveReason",
    "Archive Date*": "archiveDate",
    "Strategic Partner* (Yes/No)": "strategicPartner",
    "Business Designation Type*": "businessDesignationType",
    "Designation Level / Location Hierarchy*": "designationLevel",
    "Owner": "owner",
    "Company Email": "emailaddress",
    "Registration No": "bdoRegistrationno",
    "Country": "country",
    "City": "address1City",
    "Website URL": "companyWebsiteUrl",
    "Description": "description",
};

const ClientManagement = () => {
    const [form] = Form.useForm();
    const history = useHistory();
    const filters = useSelector(getFilters);
    const [anchorEl, setAnchorEl] = useState(null);
    const fileInputRef = useRef(null);
    const [importModal, setImportModal] = useState({ open: false, loading: false, result: null });

    const [exportData, setExportData] = useState([]);

    const xport = React.useCallback(() => {
        if (!exportData.length) return;

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Report");
        writeFileXLSX(wb, "Client Report.xlsx");
    }, [exportData]);

    const downloadTemplate = () => {
        const sampleRow = [
            "ABC Corporation",
            "Zambia",
            "Customer",
            "John Doe",
            "john@example.com",
            "Yes",
            "Ongoing",
            "john@example.com",
            "Temp@1234",
            "",
            "",
            "",
            "Zambia",
            "Lusaka",
            "",
            "",
        ];
        const ws = utils.aoa_to_sheet([TEMPLATE_HEADERS, sampleRow]);
        ws["!cols"] = TEMPLATE_HEADERS.map(() => ({ wch: 30 }));
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Client Import Template");
        writeFileXLSX(wb, "Client_Import_Template.xlsx");
    };

    const handleImportFile = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        fileInputRef.current.value = "";

        const buffer = await file.arrayBuffer();
        // cellDates: true → Excel date serials become JS Date objects
        const wb = read(buffer, { cellDates: true });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = utils.sheet_to_json(ws, { defval: "" });

        // native <input type="date"> needs YYYY-MM-DD; format any Date cells
        const toYMD = (d) => {
            const yyyy = d.getUTCFullYear();
            const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
            const dd = String(d.getUTCDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        };

        const clients = rows
            .map((row) => {
                const mapped = {};
                for (const [header, field] of Object.entries(HEADER_TO_FIELD)) {
                    const value = row[header];
                    mapped[field] =
                        value instanceof Date ? toYMD(value) : String(value ?? "").trim();
                }
                return mapped;
            })
            .filter((c) => Object.values(c).some((v) => v));

        if (clients.length === 0) {
            setImportModal({ open: true, loading: false, result: { message: "No data rows found in file.", success: [], errors: [] } });
            return;
        }

        setImportModal({ open: true, loading: true, result: null });

        try {
            const r = await CALL_API_UPDATED(
                "insyts-crm-clients?bulkImport=true",
                "post",
                { clients }
            );
            setImportModal({ open: true, loading: false, result: r?.response });
            // refresh the list so freshly imported clients show without a manual reload
            refetch();
        } catch (err) {
            setImportModal({ open: true, loading: false, result: { message: "Import failed. Please try again.", success: [], errors: [] } });
        }
    };

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const {
        getownClientsList,
        getClientsName,
        getManagingOffice,
        getClientStatus,
        getClientOwner,
        getRelationshipManager,
    } = queryKeys;
    const { key, url } = getownClientsList(filters?.client?.managingoffice ?? []);

    const { data, lastElementRef, isLoading, isReloading, refetch } = useScrollFetch(
        key,
        {
            endPoint: url,
            queryParam: "LastEvaluatedKey",
        }
    );




    const dataList = useMemo(() => {
        if (!data?.pages?.length) return [];

        const list = data.pages.reduce((acc, page) => {
            const pageList = page?.response?.clientName || [];
            return [...acc, ...pageList];
        }, []);

        // order by recently created (newest first)
        return [...list].sort((a, b) => {
            const da = a?.createdon ? new Date(a.createdon).getTime() : 0;
            const db = b?.createdon ? new Date(b.createdon).getTime() : 0;
            return db - da;
        });
    }, [data]);


    const totalFilteredClientCount = data?.pages?.[0]?.count;

    const handleCopy = () => {
        navigator.clipboard.writeText(`${window.location.origin}/clientonboard`);
        // toast.success("Link copied to clipboard!", {
        //     position: "top-center",
        //     autoClose: 1500,
        // });
    };

    console.log(dataList, "dataList")

    const importResultColumns = [
        { title: "Row", dataIndex: "row", width: 60 },
        { title: "Company Name", dataIndex: "name" },
        { title: "Client ID / Error", dataIndex: "clientId", render: (_, r) => r.clientId || <span style={{ color: "#ff4d4f" }}>{r.error}</span> },
    ];

    return (
        <ClientWrapStyle>
            <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls,.csv"
                style={{ display: "none" }}
                onChange={handleImportFile}
            />

            <Modal
                title="Bulk Import Results"
                open={importModal.open}
                onCancel={() => setImportModal({ open: false, loading: false, result: null })}
                footer={null}
                width={640}
            >
                {importModal.loading ? (
                    <div style={{ textAlign: "center", padding: 40 }}>
                        <Spin size="large" />
                        <p style={{ marginTop: 16 }}>Importing clients, please wait...</p>
                    </div>
                ) : importModal.result ? (
                    <div>
                        <p style={{ marginBottom: 16 }}>{importModal.result.message}</p>
                        {importModal.result.success?.length > 0 && (
                            <>
                                <Tag color="green" style={{ marginBottom: 8 }}>
                                    {importModal.result.success.length} Imported Successfully
                                </Tag>
                                <Table
                                    size="small"
                                    dataSource={importModal.result.success}
                                    columns={importResultColumns}
                                    rowKey="row"
                                    pagination={false}
                                    style={{ marginBottom: 16 }}
                                />
                            </>
                        )}
                        {importModal.result.errors?.length > 0 && (
                            <>
                                <Tag color="red" style={{ marginBottom: 8 }}>
                                    {importModal.result.errors.length} Failed
                                </Tag>
                                <Table
                                    size="small"
                                    dataSource={importModal.result.errors}
                                    columns={importResultColumns}
                                    rowKey="row"
                                    pagination={false}
                                />
                            </>
                        )}
                    </div>
                ) : null}
            </Modal>

            <Row justify="space-between" align="middle" className="mb-3">
                <Col>
                    <div className="page-title">Client</div>
                </Col>
                <Col style={{ display: "flex", gap: 8 }}>
                    <ButtonOutlined onClick={xport} type="link">
                        Export CSV file
                    </ButtonOutlined>
                    <ButtonOutlined onClick={downloadTemplate}>
                        Download Template
                    </ButtonOutlined>
                    <ButtonOutlined onClick={() => fileInputRef.current?.click()}>
                        Import Clients
                    </ButtonOutlined>

                    {/* <ButtonFilled onClick={() => handleCopy()}>
                        <span style={{ color: "black" }}>🔗</span>
                    </ButtonFilled> */}

                    <ButtonFilled onClick={() => history.push("/add-client")}>Add New</ButtonFilled>
                </Col>
            </Row>

            <Active
                clientList={dataList}
                // clientNames={clientNames}
                // managingOfficeName={managingOfficeName}
                // clientStatusList={clientStatusList}
                // clientOwnerList={clientOwnerList}
                // relationshipManagerList={relationshipManagerList}
                showLoader={isLoading}
                loader={isReloading}
                lastElementRef={lastElementRef}
                totalFilteredClientCount={totalFilteredClientCount}
                onSendData={setExportData}
            />
        </ClientWrapStyle>
    );
};

export default ClientManagement;
